import { useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../utils/useAuth";
import Loader from '../../src/components/Loader';

const LogIn = () => {
    const { login } = useAuth();
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');
    const [message, setMessage] = useState('');
    const [pageLoading, setPageLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setPageLoading(true);
        const res = await login(email, pass);
        if (res.isSuccess === true) {
            navigate('/');
            setPageLoading(false);
        }
        else {
            setMessage(res.message);
            setPageLoading(false);
        }
    };

    return (
        <>
            {pageLoading && <Loader />}
            <div className="row">
                <div className="col-12" style={{ marginTop: "305px" }}>
                    <div className="loginFrame">
                        <div className="loginBox avatar">
                            {/* <i className="material-icons"></i>*/}
                        </div>
                        <div style={{ marginBottom: "20px", textAlign: "center", fontSize: "22px!important" }}>
                            <h4>Login to your account</h4>
                        </div>
                        <div>
                            {
                                (message && message.length > 0) ? <div style={{ backgroundColor: "#f8d7da", color: "#721c24", borderRadius: "5px", padding: "15px", marginBottom: "10px" }} ><span>{message}</span></div> : ""
                            }
                        </div>
                        <form onSubmit={(e) => handleLogin(e)}>
                            <div className="form-group">
                                <input autoFocus style={{ height: "40px" }} type="email" className="form-control" id="email1" placeholder="Enter email" onChange={(e) => { setEmail(e.target.value); setMessage(""); }} />
                            </div>

                            <div className="form-group" style={{ marginTop: "10px!important" }}>
                                <input style={{ height: "40px" }} type="password" className="form-control" id="password" placeholder="Password" onChange={(e) => { setPass(e.target.value); setMessage(""); }} />
                            </div>

                            <div className="form-group small clearfix">
                                <label className="checkbox-inline"><input type="checkbox" formControlName="remember" /> Remember me</label>
                            </div>

                            <div style={{ marginTop: "20px" }}>
                                <button type="submit" className="btn btn-light" style={{ height: "45px", width: "100%", color: "white", backgroundColor: "#3498db", border: "1px solid lightgray" }}><i className="fas fa-sign-in-alt"></i>  Login</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}


export default LogIn;